import { atom } from 'jotai';
import { AuthSession } from '@aws-amplify/auth';

export const authSessionAtom = atom<AuthSession | null>(null);

export const authSessionLoadingAtom = atom<boolean>(true);

export const authTokenAtom = atom<string>((get) =>
    get(authSessionAtom)?.tokens?.idToken?.toString() ?? ""
);

// Cognito ユーザーの一意識別子（sub）。直近計算セット履歴の保存キー分離に用いる。
// E2E 認証バイパス等で未取得の場合は null（呼び出し側で guest キーへフォールバック）。
export const userSubAtom = atom<string | null>((get) => {
    const sub = get(authSessionAtom)?.tokens?.idToken?.payload?.sub;
    return typeof sub === 'string' ? sub : null;
});

// ヘッダー表示用のユーザー名。idToken payload から email → cognito:username の順で導出。
// 取得できない場合は空文字（表示側で「ゲスト」等にフォールバック）。
export const usernameAtom = atom<string>((get) => {
    const payload = get(authSessionAtom)?.tokens?.idToken?.payload;
    if (!payload) return '';
    const email = payload.email;
    if (typeof email === 'string' && email) return email;
    const cognitoUsername = payload['cognito:username'];
    if (typeof cognitoUsername === 'string' && cognitoUsername) return cognitoUsername;
    return '';
});
